<!-- Pagination Container -->
<ng-container *ngIf="viewModel$ | async as vm">
  <nav 
    class="pagination-container" 
    role="navigation" 
    aria-label="Pagination Navigation"
    *ngIf="vm.shouldShowPagination"
  >
    <div class="pagination-controls">
      
      <!-- Previous Page Arrow -->
      <iris-icon-button
        [type]="irisIconButtonTypes.TERTIARY"
        class="pagination-arrow pagination-arrow--previous"
        [class.disabled]="vm.isFirstPage"
        [disabled]="vm.isFirstPage"
        ariaLabel="Go to previous page"
        icon="arrow_back"
        (click)="previousPage()"
        [attr.data-test]="'pagination-previous'"
      ></iris-icon-button>
       
      <!-- Page Numbers Container -->
      <div class="pagination-pages">
        <!-- First Page -->
        <iris-button
          *ngIf="vm.shouldShowFirstPage"
          class="pagination-page-button"
          [type]="vm.firstPageInfo.buttonType"
          [attr.aria-current]="vm.firstPageInfo.ariaCurrent"
          [attr.aria-label]="vm.firstPageInfo.ariaLabel"
          (click)="goToPage(vm.firstPageInfo.page)"
          [attr.data-test]="'pagination-page-' + vm.firstPageInfo.page"
        >
          {{ vm.firstPageInfo.page }}
        </iris-button>

        <!-- Start Ellipsis -->
        <span 
          class="pagination-ellipsis"
          *ngIf="vm.showStartEllipsis"
          aria-hidden="true"
        >
          ...
        </span>
          
        <!-- Page Numbers -->
        <iris-button
          *ngFor="let pageInfo of vm.visiblePagesInfo; trackBy: trackByPageInfo"
          class="pagination-page-button"
          [type]="pageInfo.buttonType"
          [attr.aria-current]="pageInfo.ariaCurrent"
          [attr.aria-label]="pageInfo.ariaLabel"
          (click)="goToPage(pageInfo.page)"
          [attr.data-test]="'pagination-page-' + pageInfo.page"
        >
          {{ pageInfo.page }}
        </iris-button>

        <!-- End Ellipsis -->
        <span 
          class="pagination-ellipsis"
          *ngIf="vm.showEndEllipsis"
          aria-hidden="true"
        >
          ...
        </span>

        <!-- Last Page -->
        <iris-button
          *ngIf="vm.shouldShowLastPage"
          class="pagination-page-button"
          [type]="vm.totalPagesInfo.buttonType"
          [attr.aria-current]="vm.totalPagesInfo.ariaCurrent"
          [attr.aria-label]="vm.totalPagesInfo.ariaLabel"
          (click)="goToPage(vm.totalPagesInfo.page)"
          [attr.data-test]="'pagination-page-' + vm.totalPagesInfo.page"
        >
          {{ vm.totalPagesInfo.page }}
        </iris-button>
      </div>

      <!-- Next Page Arrow -->
      <iris-icon-button
        [type]="irisIconButtonTypes.TERTIARY"
        class="pagination-arrow pagination-arrow--next"
        [class.disabled]="vm.isLastPage"
        [disabled]="vm.isLastPage"
        ariaLabel="Go to next page"
        icon="arrow_forward"
        (click)="nextPage()"
        [attr.data-test]="'pagination-next'"
      ></iris-icon-button>
    </div>
  </nav>
</ng-container> 